export default "/assets/images/filter-exploded.1462ee04a69fd75e.png";